import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { I18nProvider } from './contexts/I18nContext';

// Importar scripts de limpieza para consola
import './utils/cleanupConsole';
// Importar scripts de prueba de estructura optimizada
import './utils/testOptimizedStructure';
// Importar scripts de prueba de categorías habilitadas
import './utils/testEnabledCategories';
// Importar scripts de diagnóstico
import './utils/diagnoseCategories';
// Importar scripts de prueba de actualización
import './utils/testCategoryUpdate';
// Importar scripts de verificación de funciones
import './utils/checkFirebaseFunctions';
// Importar script de creación de estructura de categorías
import './utils/createCategoriesStructure';
// Importar script de creación rápida de categorías
import './utils/createCategoriesNow';
// Importar script de creación completa de categorías
import './utils/createCompleteCategoriesStructure';
// Importar script de categorías exactas
import './utils/createExactCategories';
// Importar script de corrección de categorías
import './utils/fixCategories';
// Importar script de diagnóstico de categorías
import './utils/diagnoseCategoryIssue';
// Importar script de categorías estandarizadas
import './utils/createStandardizedCategories';
// Importar script de verificación de categorías
import './utils/checkCategories';
// Importar script de debug de categorías
import './utils/debugCategories';
// Importar script de debug simple
import './utils/simpleDebug';
// Importar script de prueba de servicio
import './utils/testInventoryService';
// Importar script de diagnóstico de duplicados
import './utils/diagnoseProductDuplicates';
// Importar script de diagnóstico de marcas y proveedores
import './utils/diagnoseBrandsAndSuppliers';
// Importar script de categorías básicas
import './utils/createBasicCategories';
// Importar script de 10 categorías completas
import './utils/createAll10Categories';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <I18nProvider>
      <ThemeProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </I18nProvider>
  </React.StrictMode>
);
